import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { DaLinkModule } from '../da-link';
import { ClickOutsideModule } from 'ng-click-outside';
import { CookieService } from 'ngx-cookie-service';
import { DesktopNavigationComponent } from './components/desktop-navigation/desktop-navigation.component';
import { MobileNavigationComponent } from './components/mobile-navigation/mobile-navigation.component';
import { NavigationUiUtilsService } from './navigation-ui-utils.service';
import { SiteNavigationComponent } from './site-navigation.component';
import { IResponsiveConfig, ResponsiveModule } from '@viablelogic/ngx-responsive';
import { SimpleNavigationComponent } from './components/simple-navigation/simple-navigation.component';
import { TranslateModule } from '@ngx-translate/core';
import { CartModule } from '../cart/cart.module';

const config : IResponsiveConfig = {
    breakPoints: {
        xs:  { max: 479 },
        sm:  { min: 480,  max: 767 },
        md:  { min: 768,  max: 959 },
        lg:  { min: 960,  max: 1119 },
        xl:  { min: 1120, max: 99999 }, // <-- workaround, as no sizes larger than xl are defined in the design
        xxl: { min: 100000}      
    },
    debounceTime: 100
};

@NgModule({
    declarations: [SiteNavigationComponent, MobileNavigationComponent, DesktopNavigationComponent, SimpleNavigationComponent],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        ClickOutsideModule,
        ResponsiveModule.forRoot(config),
        LocalizeRouterModule,
        DaLinkModule,
        CartModule,
        TranslateModule.forChild()
    ],
    exports: [SiteNavigationComponent],
    providers: [CookieService, NavigationUiUtilsService]
})
export class SiteNavigationModule {}
